var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import ReceivingScanInput from '../../receiving/ReceivingScanInput';
var OriginStep = function (_a) {
    var scanError = _a.scanError, focusSignal = _a.focusSignal, onScan = _a.onScan;
    var t = useTranslation().t;
    return (_jsxs("div", { children: [_jsx("h2", __assign({ className: 'mb-2 text-sm font-bold text-gray-700' }, { children: t('Scan Origin Location') }), void 0), _jsx(ReceivingScanInput, { placeholder: t('Scan or enter a location'), showQtyInput: false, buttonLabel: t('Go'), errorText: scanError, focusSignal: focusSignal, onSubmit: function (scanId) { return onScan(scanId); } }, void 0)] }, void 0));
};
export default OriginStep;
